import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=25f25be1&scoped=true&"
import script from "./ProductActions.vue?vue&type=script&lang=js&"
export * from "./ProductActions.vue?vue&type=script&lang=js&"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=25f25be1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f25be1",
  null
  
)

export default component.exports